var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpotify = function SvgIconSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.666c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10m4.587 14.424a.623.623 0 0 1-.858.208c-2.348-1.435-5.304-1.759-8.785-.963a.624.624 0 0 1-.277-1.215c3.81-.87 7.076-.495 9.713 1.114.294.18.387.564.207.858zm1.224-2.722a.78.78 0 0 1-1.073.256c-2.686-1.651-6.785-2.13-9.965-1.165a.78.78 0 0 1-.973-.52.78.78 0 0 1 .52-.972c3.632-1.102 8.147-.568 11.233 1.33a.78.78 0 0 1 .257 1.072zm.105-2.835c-3.223-1.915-8.54-2.09-11.618-1.156a.935.935 0 1 1-.544-1.79c3.533-1.073 9.406-.865 13.116 1.337a.936.936 0 0 1-.954 1.609"
  })));
};
export default SvgIconSpotify;